import React from 'react';

const Footer = () => {
  return (
    <footer className="mt-auto bg-white py-4 text-center">
      Made with Tailwind CSS
    </footer>
  );
};

export default Footer;
